import { useEffect, useState } from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import { ControlPoint as AddIcon } from "@mui/icons-material";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import SubstitutionsTable from "../components/SubstitutionsTable.jsx";
import SubstitutionModal from "../components/modals/SubstitutionModal.jsx";

export function SubstitutionsPage() {
  const { setBreadcrumbs } = useBreadcrumb();
  const [modalOpen, setModalOpen] = useState(false);
  const [editingSubstitution, setEditingSubstitution] = useState(null);
  const [refetchTrigger, setRefetchTrigger] = useState(0);

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Stellvertretungen", path: "/stellvertretungen" },
    ]);
  }, [setBreadcrumbs]);

  const handleOpenModal = (substitution = null) => {
    setEditingSubstitution(substitution);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setEditingSubstitution(null);
  };

  const handleSuccess = () => {
    // Trigger refetch by incrementing counter
    setRefetchTrigger((prev) => prev + 1);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
        pt: 0,
        pb: 6,
      }}
    >
      {/* Page Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h1">Stellvertretungen</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => handleOpenModal()}
          sx={{ textTransform: "none" }}
        >
          Stellvertretung erstellen
        </Button>
      </Box>

      {/* Compact Tables Row */}
      <Grid container spacing={3}>
        <Grid item size={{ md: 6, xs: 12}}>
          <SubstitutionsTable
            variant="compact"
            scope="substituting_for"
            title="Ich vertrete"
            limit={5}
            refetchTrigger={refetchTrigger}
          />
        </Grid>

        <Grid item size={{ md: 6, xs: 12}}>
          <SubstitutionsTable
            variant="compact"
            scope="substituted_by"
            title="Ich werde vertreten von"
            limit={5}
            refetchTrigger={refetchTrigger}
          />
        </Grid>
      </Grid>

      {/* Full Table */}
      <Box>
        <SubstitutionsTable
          variant="full"
          onEdit={handleOpenModal}
          refetchTrigger={refetchTrigger}
        />
      </Box>

      {/* Modal for Create/Edit */}
      <SubstitutionModal
        open={modalOpen}
        onClose={handleCloseModal}
        onSuccess={handleSuccess}
        substitution={editingSubstitution}
        isEdit={!!editingSubstitution}
      />
    </Box>
  );
}
